import * as React from 'react';
import { TextField } from 'office-ui-fabric-react';
import { deepCopy } from './formFunctions';
import { substitute } from '../../services/stringsubstitutions';

export class FormTextArea extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var { field, additional, formGenerator, collectionStack } = this.props;

        var { defaultValue, onChange, decode, validation, controller } = additional;

        var copyStack = deepCopy(collectionStack);
        copyStack.reverse();
        var formData = { ...formGenerator.getFormData() };

        field.property = substitute(field.property, controller, copyStack);

        var value = formGenerator.getFormData()[field.property];
        if (value == null && defaultValue != null) {
            var defaultVal = substitute(defaultValue, controller, [formData, ...copyStack]);
            if (defaultVal !== '') {
                value = defaultVal;
                formData[field.property] = value;
            }
        }

        if (value != null && field.settings != null && field.settings.formatter != null) {
            var obj = JSON.parse(value);
            value = JSON.stringify(obj, null, 3);
        }
        if (field.readOnly != null) field.readonly = field.readOnly;

            var onKeyPress = (val) => {
            var keyPressed = {
                charCode: val.charCode,
                altKey: val.altKey,
                ctrlKey: val.ctrlKey,
                shiftKey: val.shiftKey, 
            };

            if (field?.events?.onEnter != null && keyPressed.charCode === 13 && keyPressed.shiftKey === false) {
                val.preventDefault();  
                val.stopPropagation();  
                var formData = { ...formGenerator.getFormData() };
                formGenerator.runActions(field, field.events.onEnter, {}, formData, copyStack);
                return;
            }


            if (field.onKeyPress == null) return;

            var formData = { ...formGenerator.getFormData() };
            formGenerator.runActions(field, field.onKeyPress, { keyPressed }, formData, copyStack);
        };
        var self = this;
        var getValue = (isLoading) => {
            var fd = formGenerator.getFormData();
            var val = fd[field.property];
            if (val != null) {
                val = val.toString();
            }

            if (!isLoading && field.onUpdate && val != self.previousValue) {
                formGenerator.runActions(field, field.onUpdate, {}, fd, copyStack);
                self.previousValue = val;
            }

            if (isLoading) self.previousValue = val;

            if (val == null && field.defaultValue != null) {
                var defaultVal = substitute(defaultValue, controller, [formData, ...copyStack]);
                if (defaultVal !== '') {
                    val = defaultVal;
                    fd[field.property] = val;
                }
            }
            return val;
        };


        return (
            <TextField
              rows={field.settings.rows}
                id={field.id}
                className={`form-textarea ${field.class || ''}`}
                key={field.property}
                label={field.header}
                style={field.styles}
                prefix={field.settings.prefix}
                disabled={decode(field, field.disabled)}
                onKeyPress={(e) => onKeyPress(e)}

                type={field.subType != null ? field.subType : null}
                multiline={true}
                onGetErrorMessage={validation}
                required={decode(field, field.required)}
                readOnly={decode(field, field.readonly)}
                deferredValidationTime={field.settings.deferredValidationTime}
                validateOnFocusOut={field.settings.validateOnFocusOut}
                placeholder={field.placeholder}
                value={value}
                onChange={(e, val) => {
                    onChange(field, val, copyStack);
                }}
            />
        );
    }
}
